"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsBreakdownRequest = exports.PaymentsBreakdownTransport = exports.PaymentsBreakdownItem = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PaymentsBreakdownItem = typebox_1.Type.Object({
    invoiceNumber: typebox_1.Type.String(),
    dateOfPayment: typebox_1.Type.String({ format: 'date' }),
    customerName: typebox_1.Type.String(),
    creditCardLastFour: typebox_1.Type.String(),
    grossPaymentAmount: typebox_1.Type.Integer(),
    paymentFeeAmount: typebox_1.Type.Integer(),
    totalPaymentAmount: typebox_1.Type.Integer(),
});
exports.PaymentsBreakdownTransport = typebox_1.Type.Object({
    payments: typebox_1.Type.Array(exports.PaymentsBreakdownItem),
});
exports.PaymentsBreakdownRequest = typebox_1.Type.Object({
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.String({ format: 'date' }),
});
//# sourceMappingURL=payments-breakdown-report.js.map